import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? 'border-b border-background-200/80 bg-background-50/95 backdrop-blur'
          : 'border-b border-transparent bg-transparent'
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between px-4 md:h-20 md:px-8">
        <a href="#top" className="flex cursor-pointer items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-compass-3-line text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950 md:text-xl">
              黑料导航
            </span>
            <span className="font-label text-[10px] tracking-[0.22em] text-foreground-500">
              MENU &amp; DIRECTORY
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#submit"
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 md:flex"
          >
            <i className="ri-add-circle-line text-base" />
            提交收录
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer rounded-md border border-background-200 bg-background-100 px-3 py-2.5 font-label text-sm text-foreground-800"
              >
                {link.label}
              </a>
            ))}
          </div>
          <a
            href="#submit"
            onClick={() => setMenuOpen(false)}
            className="mt-3 flex cursor-pointer items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm text-background-50"
          >
            <i className="ri-add-circle-line text-base" />
            提交收录
          </a>
        </div>
      )}
    </header>
  );
}